var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m248 224v56l-32 96-80 64-43.59-26.15 75.59-61.85v-128z",
    fill: "#ffceb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m136 440v48h-24l-32-64 12.41-10.154z",
    fill: "#e0edff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m208 56h48a0 0 0 0 1 0 0v24a24 24 0 0 1 -24 24 24 24 0 0 1 -24-24v-24a0 0 0 0 1 0 0z",
    fill: "#ffceb6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m208 56v-16l19.359-12.906a18.42223 18.42223 0 0 1 10.21879-3.094 18.42218 18.42218 0 0 1 18.42221 18.42219v13.57781z",
    fill: "#c78640"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m431.99557 120.46528c-.25015 13.16394-11.37936 23.53472-24.54567 23.53472h-7.4499l-16-8-96 12.8-24 3.2-16 56 82.65839 82.65839a32 32 0 0 1 7.73045 12.50813l45.61116 136.83348-40 24-56-128-33.6001-22.4-68.58984-45.73a39.97027 39.97027 0 0 1 -17.81006-33.28v-82.59a56 56 0 0 1 56-56h184a24.00209 24.00209 0 0 1 23.99557 24.46528z",
    fill: "#ffceb6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m344 464v24h88v-16l-48-32z",
    fill: "#e0edff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m248 224v56l-19.13 57.39-60.87-17.39v-96z",
    fill: "#ffa100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m304 264-49.6001 49.6-68.58984-45.73a39.97027 39.97027 0 0 1 -17.81006-33.28v-26.59h80z",
    fill: "#ffb401"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m288 96v52.80005l-24 3.19995-16 56h-80v-56a55.99746 55.99746 0 0 1 56-56z",
    fill: "#548aff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/boxing.b124ca977e428c369ce6a038c1cad148.svg";
export { ForwardRef as ReactComponent };